import { render, staticRenderFns } from "./Riskmatrixcategories.vue?vue&type=template&id=a09ea000&scoped=true"
import script from "./Riskmatrixcategories.vue?vue&type=script&lang=js"
export * from "./Riskmatrixcategories.vue?vue&type=script&lang=js"
import style0 from "./Riskmatrixcategories.vue?vue&type=style&index=0&id=a09ea000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09ea000",
  null
  
)

export default component.exports